import { render, staticRenderFns } from "./task-relation-badge.vue?vue&type=template&id=b001a84e&scoped=true"
import script from "./task-relation-badge.vue?vue&type=script&lang=js"
export * from "./task-relation-badge.vue?vue&type=script&lang=js"
import style0 from "./task-relation-badge.vue?vue&type=style&index=0&id=b001a84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b001a84e",
  null
  
)

export default component.exports